import styled from 'styled-components';

const dark_blue = '#67737d';
const red = '#bf303c';

export const TableSytle = styled.div`
  margin-top: 150px;
  max-width: 1595px;
  width: 100%;
  overflow: hidden !important;
`;

export const HorizontalContainer = styled.div`
  display: flex;
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CellHeader = styled.div`
  font-size: 16px;
  font-weight: 700;
  line-height: 50px;
  width: 282px;
  height: 50px;
  text-align: left;
  border-bottom: 1px ${dark_blue} solid;
  border-right: 1px ${dark_blue} solid;
  border-top: 1px ${dark_blue} solid;
  margin: -1px;
`;

export const CellHeader2 = styled.div`
  font-size: 16px;
  line-height: 50px;
  width: 282px;
  height: 50px;
  text-align: left;
  border-bottom: 1px ${dark_blue} solid;
  border-right: 1px ${dark_blue} solid;
  border-top: 1px ${dark_blue} solid;
  margin: -1px;

  padding-left: 20px;
`;

export const CellStyle = styled.div`
  cursor: pointer;
  font-size: 16px;
  text-align: center;
  //   line-height: 50px;
  padding: 20% 0;
  margin: auto;
  width: 85px;
  height: 50px;
  // box-shadow: var(--cell-shadow);
  border: 1px ${dark_blue} solid;
  margin: -1px;
  position: relative;
  //   z-index: 1;

  .tips {
    position: absolute;
    top: 4px;
    right: 5px;
    display: inline-block;
    font-size: 12px;
    color: ${red};
  }

  #tips {
    display: inline-block;
    position: absolute;
    right: 25px;
    top: -5px;
    line-height: 15px;
    font-size: 15px;
    font-weight: 600;
    color: ${red};
    background-color: #fff;
    border: ${red} 2px solid;
    border-radius: 20px;
    padding: 5px 10px;
    z-index: inherit;
  }
`;

export const UpdateCellInput = styled.input`
  margin-top: -10px;
  width: 74px;
  height: 49px;
  z-index: 1;
`;

export const UpdateInventoryButton = styled.div`
  position: absolute;
  top: 35px;
  right: 2px;
  font-size: 13px;
  padding: 8px 10px;
  line-height: 13px;
  color: #fff;
  background-color: #26a746;
  border-radius: 16px;
  z-index: 1;
`;
